import React, { useState } from "react";

const MumbaiPuneCabSection = () => {
  const [readMore, setReadMore] = useState(false);

  const containerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "60px 20px",
    maxWidth: "1200px",
    margin: "auto",
    gap: "40px",
    flexWrap: "wrap",
  };

  const textSection = {
    flex: "1",
    minWidth: "300px",
  };

  const imageSection = {
    flex: "1",
    textAlign: "center",
  };

  const imageStyle = {
    width: "100%",
    maxWidth: "500px",
    borderRadius: "12px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
  };

  const headingStyle = {
    fontSize: "36px",
    fontWeight: "600",
    marginBottom: "10px",
  };

  const subHeadingStyle = {
    color: "#e74c3c",
    fontWeight: "600",
    fontSize: "18px",
    marginBottom: "15px",
  };

  const paragraphStyle = {
    fontSize: "15px",
    lineHeight: "1.7",
    color: "#444",
    marginBottom: "15px",
  };

  const buttonStyle = {
    padding: "10px 20px",
    backgroundColor: "#a5542a",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
  };

  return (
    <>
    
      {/* Breadcrumb */}
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title">Mumbai Outstation Cabs</h2>
            </div>
          </div>
        </div>
      </div>
    
    
    <div style={containerStyle}>
      
      {/* LEFT CONTENT */}
      <div style={textSection}>
        <h2 style={headingStyle}>Mumbai to Pune Cab Service</h2>

        <div style={subHeadingStyle}>
          Estimated Travel Time: 3–4 Hours
        </div>

        <p style={paragraphStyle}>
          Travel from Mumbai to Pune with ease using Velocity Cab’s trusted cab
          services. Whether you’re leaving from the airport, railway station, or
          any location in Mumbai, we provide door-to-door pickup and drop for
          maximum convenience.
        </p>

        <p style={paragraphStyle}>
          Enjoy a relaxed journey through the Mumbai–Pune Expressway with
          beautiful landscapes and smooth roads. Our drivers are familiar with
          traffic patterns and take the best routes to save your time.
        </p>

        {/* READ MORE CONTENT */}
        {readMore && (
          <p style={paragraphStyle}>
            We offer flexible options including one-way trips, round trips, and
            customized travel packages. With affordable pricing and 24/7
            availability, Velocity Cab is your perfect travel partner for safe,
            comfortable, and reliable journeys.
          </p>
        )}

        {/* BUTTON */}
        <button
          style={buttonStyle}
          onClick={() => setReadMore(!readMore)}
        >
          {readMore ? "Show Less" : "Read More"}
        </button>
      </div>

      {/* RIGHT IMAGE */}
      <div style={imageSection}>
        <img
          src="https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?q=80&w=1000"
          alt="Mumbai to Pune Cab"
          style={imageStyle}
        />
      </div>
    </div>
    </>
  );
};

export default MumbaiPuneCabSection;